import { Component, OnInit,Input } from '@angular/core';
import { NavParams, AlertController, ModalController, LoadingController } from '@ionic/angular';

@Component({
  selector: 'app-modal-tickets-sin-tarifa',
  templateUrl: './modal-tickets-sin-tarifa.page.html',
  styleUrls: ['./modal-tickets-sin-tarifa.page.scss'],
})
export class ModalTicketsSinTarifaPage implements OnInit {
  @Input() arraydetickets;
  arrayfinal=[]

  constructor(public alertController:AlertController, public modalController:ModalController, public loadingController: LoadingController) { }

  ngOnInit() {
    //como el resultado es un array con arrays internos, toca iterar dentro de la iteración para sacar el resultado
    this.arraydetickets.forEach((item) => {
      item.forEach((element) => {
        this.arrayfinal.push(element)
      });
    });
  }




}
